import { render, staticRenderFns } from "./Eventlist.vue?vue&type=template&id=5b3f07b7&"
import script from "./Eventlist.vue?vue&type=script&lang=js&"
export * from "./Eventlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports